import type { SendMode } from "@/features/BroadcastV2/store/broadcastComposeStoreFactory";
import type { Frame } from "@/types/dragon-tiles";

import { isBlankText } from "@/frames/subjectLine";

/** A variation whose email frame is missing a subject and/or preview. */
export interface EmptyFieldWarning {
  /** Variation label ("Variation A"); empty string when not A/B. */
  label: string;
  missingSubject: boolean;
  missingPreview: boolean;
}

export function frameSubjectPreviewWarning(
  frame: Frame | null | undefined,
  label: string,
): EmptyFieldWarning | null {
  const config = frame?.frame_variants.find(
    (fv) => fv.medium === "email",
  )?.config;
  if (!config) return null;
  const missingSubject = isBlankText(config.subject_line);
  const missingPreview = isBlankText(config.preview_text);
  if (!missingSubject && !missingPreview) return null;
  return { label, missingSubject, missingPreview };
}

export function missingSubjectLineMessage(
  warnings: EmptyFieldWarning[],
  sendMode: SendMode,
): string {
  const labels = warnings.map((w) => w.label).filter(Boolean);
  const target =
    labels.length > 0
      ? ` to ${new Intl.ListFormat("en", { type: "conjunction" }).format(labels)}`
      : "";
  const action = sendMode === "instant" ? "sending" : "scheduling";
  return `Add a subject line${target} before ${action}.`;
}
